// Global "endless" mode leaderboard, backed by a Supabase table (see
// README.md for the one-time setup: create a `scores` table with row-level
// security allowing public insert + select, nothing else). Talked to
// directly via fetch() against Supabase's auto-generated REST API — no
// server code of our own to write or host.
//
// Fill these in once you've created your Supabase project (Project
// Settings -> API). The anon key is meant to be public/client-exposed —
// row-level security is what actually protects the table, not secrecy of
// this key. Leave SUPABASE_URL empty to keep the leaderboard disabled
// (submit/fetch calls no-op) until it's configured.
const SUPABASE_URL = 'https://ntggesofppivktkiibwi.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_9orET6HZyr_NWbXAdhmBrw_JwPFEJgM';

export const LEADERBOARD_ENABLED = !!SUPABASE_URL;

function headers() {
  return {
    apikey: SUPABASE_ANON_KEY,
    Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
    'Content-Type': 'application/json'
  };
}

/** Submits one score. Resolves silently on failure — a leaderboard write should never block/crash the death screen. */
export async function submitScore(initials, score) {
  if (!LEADERBOARD_ENABLED) return false;
  try {
    const res = await fetch(`${SUPABASE_URL}/rest/v1/scores`, {
      method: 'POST',
      headers: { ...headers(), Prefer: 'return=minimal' },
      body: JSON.stringify({ initials, score })
    });
    return res.ok;
  } catch {
    return false;
  }
}

/** Fetches the top `limit` scores, highest first. Returns [] on failure or if not configured. */
export async function fetchTopScores(limit = 10) {
  if (!LEADERBOARD_ENABLED) return [];
  try {
    const res = await fetch(
      `${SUPABASE_URL}/rest/v1/scores?select=initials,score&order=score.desc&limit=${limit}`,
      { headers: headers() }
    );
    if (!res.ok) return [];
    return await res.json();
  } catch {
    return [];
  }
}
